<div class="imc--alerta">
  <h2
    mat-dialog-title
    [ngClass]="{
      warning: data.tipo === 'warning',
      error: data.tipo === 'error' || data.tipo === 'logout',
      success: data.tipo === 'success',
      confirm: data.tipo === 'confirm'
    }"
  >
    {{ data.titulo }}
  </h2>

  <mat-dialog-content
    [ngClass]="{
      warning: data.tipo === 'warning',
      error: data.tipo === 'error' || data.tipo === 'logout',
      success: data.tipo === 'success',
      confirm: data.tipo === 'confirm'
    }"
  >
    <p *ngIf="data.esTextoHtml" [innerHTML]="data.mensaje"></p>
    <p *ngIf="!data.esTextoHtml">{{ data.mensaje }}</p>
  </mat-dialog-content>

  <mat-dialog-actions
    [ngClass]="{
      warning: data.tipo === 'warning',
      error: data.tipo === 'error' || data.tipo === 'logout',
      success: data.tipo === 'success',
      confirm: data.tipo === 'confirm'
    }"
    fxLayout="column"
    fxLayoutAlign="end center"
  >
    <div *ngIf="data.tipo === 'confirm' || data.tipo === 'logout'">
      <button mat-button *ngIf="data.txtSuccess == null" (click)="accionSuccess()" class="imc--bt-accepta tel-button normal_size">
        {{ 'ACCEPT' | translate }}
      </button>
      <button mat-button *ngIf="data.txtReject == null" (click)="accionReject()" class="tel-button normal_size light_option">
        {{ 'CANCEL' | translate }}
      </button>

      <button mat-button *ngIf="data.txtSuccess != null" (click)="accionSuccess()" class="imc--bt-accepta tel-button normal_size">{{ data.txtSuccess }}</button>
      <button mat-button *ngIf="data.txtReject != null" (click)="accionReject()" class="tel-button normal_size light_option">{{ data.txtReject }}</button>
    </div>
    <div *ngIf="data.tipo !== 'confirm' && data.tipo !== 'logout'">
      <button class="tel-button-icon normal_size" (click)="accionSuccess()">{{ 'ACCEPT' | translate }}</button>
    </div>
  </mat-dialog-actions>
</div>
